import { PageController } from '@client/components/_core/layout/PageController';
import { EntityFlagEdit } from '@client/components/_shared/flags/EntityFlagEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/flags/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New flag',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <EntityFlagEdit module="complaint" action={['add']} />
        </PageController>
    );
}
